const ONBOARDING_CACHE_KEY  = 'onboardingPassed';
export const getOnboardingPassed = (): boolean => {
    const onboardingPassed = localStorage.getItem(ONBOARDING_CACHE_KEY);
    return onboardingPassed === 'yes';
}

export const setOnboardingPassed = (): void => {
    localStorage.setItem(ONBOARDING_CACHE_KEY, 'yes');
}
